import { FuseNavigationItem } from '@fuse/components/navigation';
import { Message } from 'app/layout/common/messages/messages.types';
import { Notification } from 'app/layout/common/notifications/notifications.types';
import { Shortcut } from 'app/layout/common/shortcuts/shortcuts.types';
import { Profile } from 'app/modules/profile/profile.model';
import { OptionsSelect as KeyValue } from './shared/ashcorp-controllers/select/select.component';

export interface InitialData {
    messages: Message[];
    navigation: {
        compact: FuseNavigationItem[],
        default: FuseNavigationItem[],
        futuristic: FuseNavigationItem[],
        horizontal: FuseNavigationItem[]
    };
    notifications: Notification[];
    shortcuts: Shortcut[];
    user: Profile;
}

export interface ToasterMessage {
    message: string;
    type: 'success' | 'error';
}

export interface ApiResponse<T = any> {
    id: string;
    httpCode: number;
    code: string;
    title: string;
    status: 'success' | 'error' | 'alert';
    payload: T;
    errors: T;
    message: string;
}

export interface ValidationError {
    error: string;
    name: string;
    label: string;
    type: string;
    received: string;
    expected: string;
    message: string;
}


export interface E_Payload {
    error_id: string;
    id: ValidationError;
    code: ValidationError;
    name: ValidationError;
    status: ValidationError;
}

export interface ValidationErrorPayload {
    [key: string]: ValidationError | string;
}

export class QPaged<T> {
    page?: number = 1;
    size?: number = 10;
    sort?: string = '';
    order?: string = 'asc';
    exclusive?: boolean = false;

    conditions?: T;
}

export interface PStatusUpdate {
    id: number;
    status: string;
}

export interface RQueryPaged<T> {
    items: T[];
    count: number;
}

export interface ROptionItem {
    id: number;
    label: string;
}

export interface RLayoutItem {
    theme: string;
    logo: string;
    watermark: string;
    favicon: string;
}

export interface RContactItem {
    email: string;
    lastname: string;
    othernames: string;
    mobile: string;
}

export interface RUserIdentityItem {
    id?: number;
    email?: string;
    fullname?: string;
}

export interface RMetaItem {
    created_by?: RUserIdentityItem;
    created_on?: string;
    updated_by?: RUserIdentityItem;
    updated_on?: string;
}

export const OPTIONS_STATUS: KeyValue = [
    { label: 'Active', value: 'ACTIVE' },
    { label: 'Inactive', value: 'INACTIVE' }
] as const;

export const OPTIONS_ACCESS: KeyValue = [
    { label: 'Granted', value: 'GRANTED' },
    { label: 'Revoked', value: 'REVOKED' }
] as const;

export const OPTIONS_ROLE: KeyValue = [
    { label: 'Super Admin', value: '@SUPERADMIN' },
    { label: "Admin", value: "@ADMIN" },
    { label: "Manager", value: "@MANAGER" },
    { label: "User", value: "@USER" }
] as const;

export const MODULE_COMPONENTS: KeyValue = [
    { label: 'Dashboard', value: 'dashboard' },
    { label: 'Accounts', value: 'accounts' },
    { label: 'Campaigns', value: 'campaigns' },
    { label: 'Payroll', value: 'payroll' },
    { label: 'Settings', value: 'settings' },
    { label: 'Users', value: 'users' }
] as const;

export type EOptionsStatus = typeof OPTIONS_STATUS[number];
export type EOptionsAccess = typeof OPTIONS_ACCESS[number];
export type EOptionsRole = typeof OPTIONS_ROLE[number];
export type EOptionModule = typeof MODULE_COMPONENTS[number];